import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {assertNoBatching} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/utils/image-op-utils"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpConvolveHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/convolve/hal"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/convolve/definition"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"
import {BorderMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/convolve-helper-hal"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeConvolve"}

@registerImageOpNode
export class ImageOpNodeConvolve extends BasicSpecializingImageOpNode<typeof definition, ImageOpConvolveHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpConvolveHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const {sourceImage, kernel, borderMode} = await evaluator.getAll(parameters)
        assertNoBatching(sourceImage.descriptor)
        if (kernel.values.length != kernel.width * kernel.height) {
            throw new Error("Kernel values array length doesn't match the kernel size")
        }
        const translateBorderMode = (borderMode: BorderMode) => {
            switch (borderMode) {
                case "border":
                    return "zero"
                default:
                    return borderMode
            }
        }
        return createImageOpImgProc(sourceImage.descriptor, {
            type: "convolve",
            input: sourceImage.node,
            kernel: {
                type: "constKernel",
                width: kernel.width,
                height: kernel.height,
                data: kernel.values,
            },
            borderMode: translateBorderMode(borderMode),
        })
    }
}
